module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-ThinItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-ThinItalic-webfont.svg
// module id = 1627
// module chunks = 0